import { BevelCutTypePreference, TrussDefinitionType, TrussEnvelope, TrussType } from '@paragon/contract-library';

import { SerializedEntitySnapTarget } from '../../layout-snapping/EntitySnapTarget';
import { DistanceSnappingSettings } from '../../layout-snapping/truss-envelope-snapping/distance';

export type TrussEnvelopeSnappingBehaviorMode = 'closest-target' | 'closest-result';

export interface TrussEnvelopeSnappingSettings {
  readonly distanceSettings: DistanceSnappingSettings;
  readonly behaviorMode: TrussEnvelopeSnappingBehaviorMode;

  readonly lockedTarget: SerializedEntitySnapTarget | null;
}

export interface TrussEnvelopeInsertionSettings {
  readonly snapping: TrussEnvelopeSnappingSettings;
  readonly bevelCutTypePreference: BevelCutTypePreference;

  readonly lastComponentType: TrussType;
  readonly lastRoofTrussDefinitionType: TrussDefinitionType;
  readonly defaultProperties: Record<TrussDefinitionType, TrussEnvelopePersistedDefaultProperties>;
}

export const TRUSS_ENVELOPE_PROPERTIES_PERSISTED_IN_SETTINGS = [
  'justification',
  'thickness',
  'numberOfPlies',
] as const satisfies (keyof TrussEnvelope)[];

export type TrussEnvelopePersistedDefaultProperties = Pick<
  TrussEnvelope,
  (typeof TRUSS_ENVELOPE_PROPERTIES_PERSISTED_IN_SETTINGS)[number]
>;
